import React from 'react';
import { createRoot } from 'react-dom/client';
import {
	createBrowserRouter,
	RouterProvider,
	BrowserRouter,
} from 'react-router-dom';
import App from './app';
import './style.css';
import { AppProvider } from './app/context/AppContextBeta';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { CookiesProvider } from 'react-cookie';
import './index.css';
import { SettingsProvider } from './app/context/SettingsContext';

const router = createBrowserRouter([
	{
		path: '*', // root path
		element: (
			<AppProvider>
				<SettingsProvider>
					<App />
				</SettingsProvider>
			</AppProvider>
		),
	},
]);

const Client = () => (
	<CookiesProvider>
		<DndProvider backend={HTML5Backend}>
			<BrowserRouter>
				<SettingsProvider>
					<AppProvider>
						<App />
					</AppProvider>
				</SettingsProvider>
			</BrowserRouter>
		</DndProvider>
	</CookiesProvider>
);

const container = document.getElementById('app');
const root = createRoot(container);
root.render(<Client />);
